// What a caller asked, shared by the call panel's Ask tab, the Caller questions page and the server routes
// (server/callAssist.ts). One wording is one group on the questions page, so the grouping key is computed in one place.

export const QUESTION_MAX = 500;
export const ANSWER_MAX = 2000;

/** The grouping key of a question: lower case, letters (any script), digits and single spaces only. */
export function normQuestion(s: string): string {
  return s
    .toLowerCase()
    .replace(/[^\p{L}\p{N}\s]+/gu, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, QUESTION_MAX);
}

/** POST /api/calls/assist → the script to read out; `confident` false when the event's facts do not say. */
export interface AssistAnswer { answer: string; confident: boolean }

/** POST /api/calls/questions → the saved question. */
export interface SentQuestion { id: string }

export type QuestionStatus = 'sent' | 'answered' | 'dismissed';

/** One row of call_questions as the Caller questions page reads it. */
export interface CallQuestionRow {
  id: string;
  event_id: string;
  call_id: string | null;
  question: string;
  question_norm: string;
  ai_answer: string | null;
  status: QuestionStatus;
  admin_answer: string | null;
  answered_at: string | null;
  created_at: string;
}
